export const Grain = () => (
  <div className="grain-bg pointer-events-none fixed inset-0 z-[999] opacity-[0.04] mix-blend-overlay" aria-hidden="true" />
);
